var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticClass: "invoice-preview-wrapper" },
      [
        _c(
          "b-row",
          { staticClass: "invoice-preview justify-content-center" },
          [
            _c(
              "b-col",
              { attrs: { cols: "10" } },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "invoice-preview-card",
                    attrs: { "no-body": "" },
                  },
                  [
                    _c("b-card-body", { staticClass: "invoice-padding pb-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center flex-md-row flex-column mt-0",
                        },
                        [
                          _c("div", { staticClass: "text-center" }, [
                            _c("h1", { staticClass: "invoice-logo" }, [
                              _vm._v(_vm._s(this.userData.username)),
                            ]),
                            _c("h1", { staticClass: "invoice-logo" }, [
                              _vm._v("Profit and Loss"),
                            ]),
                            _c("h3", [_vm._v("01 Jan 2025 - 31 Dec 2025")]),
                          ]),
                        ]
                      ),
                    ]),
                    _c("hr", { staticClass: "invoice-spacing" }),
                    _c(
                      "b-card-body",
                      { staticClass: "invoice-padding py-0" },
                      [
                        _c(
                          "b-row",
                          { staticClass: "invoice-spacing" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "p-0", attrs: { cols: "12" } },
                              [
                                _c(
                                  "h5",
                                  {
                                    directives: [
                                      {
                                        name: "b-toggle",
                                        rawName: "v-b-toggle.assets",
                                        modifiers: { assets: true },
                                      },
                                    ],
                                    staticClass: "text-uppercase",
                                  },
                                  [_c("u", [_vm._v("INCOMES")])]
                                ),
                              ]
                            ),
                            _c(
                              "b-collapse",
                              {
                                staticClass: "row w-100",
                                attrs: { visible: "", id: "assets" },
                              },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "w-100" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "py-0 pr-0 pl-3",
                                        attrs: { cols: "6" },
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "card-text mb-25" },
                                          [_vm._v("Sales")]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "p-0 mt-xl-0 mt-2 d-flex justify-content-end",
                                        attrs: { xl: "6", cols: "6" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-bolder justify-content-end text-right",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "card-text mb-25",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(this.currency) +
                                                    " " +
                                                    _vm._s(
                                                      Number(
                                                        this.profitandloss.sales
                                                      ).toFixed(2)
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("b-col", { attrs: { cols: "12" } }, [
                                  _c("h5", { staticClass: "text-capitalize" }, [
                                    _vm._v("Other Incomes:"),
                                  ]),
                                ]),
                                _vm._l(
                                  this.profitandloss.otherIncomes,
                                  function (asset, index) {
                                    return _c(
                                      "b-row",
                                      { key: index, staticClass: "w-100" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "py-0 pr-0 pl-3",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "card-text mb-25",
                                              },
                                              [_vm._v(_vm._s(asset.name))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "p-0 mt-xl-0 mt-2 d-flex justify-content-end",
                                            attrs: { xl: "6", cols: "6" },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "font-weight-bolder justify-content-end text-right",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "card-text mb-25",
                                                  },
                                                  [_vm._v(_vm._s(asset.total))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _c(
                              "b-row",
                              { staticClass: "w-100" },
                              [
                                _c(
                                  "b-col",
                                  { staticClass: "mt-2", attrs: { cols: "6" } },
                                  [
                                    _c(
                                      "h5",
                                      { staticClass: "text-uppercase" },
                                      [_vm._v("GROSS PROFIT")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "mt-xl-2 mt-2 d-flex justify-content-end",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bolder justify-content-end text-right",
                                      },
                                      [
                                        _c("hr", { staticClass: "my-50" }),
                                        _c(
                                          "p",
                                          { staticClass: "card-text mb-25" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(this.currency) +
                                                " " +
                                                _vm._s(
                                                  (
                                                    Number(
                                                      this.profitandloss.sales
                                                    ) +
                                                    this.profitandloss.otherIncomes.reduce(
                                                      function (acc, asset) {
                                                        return acc + asset.total
                                                      },
                                                      0
                                                    )
                                                  ).toFixed(2)
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("hr", { staticClass: "my-25" }),
                                        _c("hr", { staticClass: "my-25" }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-card-body",
                      { staticClass: "invoice-padding py-0" },
                      [
                        _c(
                          "b-row",
                          { staticClass: "invoice-spacing" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "p-0", attrs: { cols: "12" } },
                              [
                                _c(
                                  "h5",
                                  {
                                    directives: [
                                      {
                                        name: "b-toggle",
                                        rawName: "v-b-toggle.liabilities",
                                        modifiers: { liabilities: true },
                                      },
                                    ],
                                    staticClass: "text-uppercase",
                                  },
                                  [_c("u", [_vm._v("EXPENSES")])]
                                ),
                              ]
                            ),
                            _c(
                              "b-row",
                              { staticClass: "w-100" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "py-0 pr-0 pl-3",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "card-text mb-25" },
                                      [_vm._v("Expenses")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "p-0 mt-xl-0 mt-2 d-flex justify-content-end",
                                    attrs: { xl: "6", cols: "6" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bolder justify-content-end text-right",
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "card-text mb-25" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(this.currency) +
                                                " " +
                                                _vm._s(
                                                  Number(
                                                    this.profitandloss.expenses
                                                  ).toFixed(2)
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c("h5", { staticClass: "text-capitalize" }, [
                                _vm._v("Other Expenses:"),
                              ]),
                            ]),
                            _vm._l(
                              this.profitandloss.otherExpenses,
                              function (asset, index) {
                                return _c(
                                  "b-row",
                                  { key: index, staticClass: "w-100" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "py-0 pr-0 pl-3",
                                        attrs: { cols: "6" },
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "card-text mb-25" },
                                          [_vm._v(_vm._s(asset.name))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "p-0 mt-xl-0 mt-2 d-flex justify-content-end",
                                        attrs: { xl: "6", cols: "6" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-bolder justify-content-end text-right",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "card-text mb-25",
                                              },
                                              [_vm._v(_vm._s(asset.total))]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      { staticClass: "w-100" },
                      [
                        _c(
                          "b-card-body",
                          { staticClass: "invoice-padding py-0" },
                          [
                            _c(
                              "b-row",
                              { staticClass: "invoice-spacing" },
                              [
                                _c("b-col", { attrs: { cols: "6" } }, [
                                  _c("h5", { staticClass: "text-uppercase" }, [
                                    _vm._v("NET PROFIT & LOSS"),
                                  ]),
                                ]),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "mt-xl-0 mt-2 d-flex justify-content-end",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bolder justify-content-end text-right",
                                      },
                                      [
                                        _c("hr", { staticClass: "my-50" }),
                                        _c(
                                          "p",
                                          { staticClass: "card-text mb-25" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(this.currency) +
                                                " " +
                                                _vm._s(
                                                  (
                                                    Number(
                                                      this.profitandloss.sales +
                                                        this.profitandloss.otherIncomes.reduce(
                                                          function (
                                                            acc,
                                                            asset
                                                          ) {
                                                            return (
                                                              acc + asset.total
                                                            )
                                                          },
                                                          0
                                                        )
                                                    ) -
                                                    (Number(
                                                      this.profitandloss
                                                        .expenses
                                                    ) +
                                                      +this.profitandloss.otherExpenses.reduce(
                                                        function (acc, asset) {
                                                          return (
                                                            acc + asset.total
                                                          )
                                                        },
                                                        0
                                                      ) +
                                                      Number(
                                                        this.profitandloss
                                                          .taxExpenses
                                                      ))
                                                  ).toFixed(2)
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("hr", { staticClass: "my-25" }),
                                        _c("hr", { staticClass: "my-25" }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }